export default {
  others: {
    en: '& Other',
  },
  freebet: {
    en: 'Freebet',
  },
  events: {
    en: 'events:',
  },
  combo: {
    en: 'Combo',
  },
  buttonTitle: {
    en: 'Details & Cash-out',
  },
  overtimeButtonTitle: {
    en: 'Details',
  },
}
